<template>
<div>
    <loader v-if="pageLoader"></loader>
    <div v-if="trans_id == '' && !congModule">
        <alert-notification v-if="notification_msg != ''"/>
        <div class="mainTitle section_title m-0 text-center">
            <h5 class="mb-3 mb-md-4 d-block">Please Enter Your New Mobile Number Below</h5>
        </div>
        <div class="CustomBlockWidth SupportBlockCenter  mb-3"> 
            <div class="form-group field-wrapper" v-if="get_user.mobile_no"> 
                <input placeholder=" " class="form-control"  v-model="get_user.mobile_no" type="text"  disabled=""> 
                <label class="labeltext active">Existing Mobile Number</label>
            </div>
            <div class="form-group field-wrapper"> 
			    <vue-phone-number-input v-model="new_mobile"  :no-example="true" :default-country-code="userCountry" v-validate="{ required: true,max:15 }" ref="new_mobileInput" :class="{ 'is-invalid': submitted && errors.has('new_mobile') }" name="new_mobile" @update="updatedText"/>
                <p class="error" v-if="!(numberValid)">Invalid Number</p>
                <p class="error" v-for="error in errors.collect('new_mobile')">Mobile Number is Required</p>
            </div>   
            <div class="text-center">
                <button class="cap_btn-b blue mt-4" v-on:click="$parent.editNumber = false">Cancel</button> 
                <button class="cap_btn large_btn blue mt-4"  :class="(pageLoader)?'disabled':''"v-on:click="submitNow()">Change Mobile Number</button> 
            </div>
        </div> 
    </div>
    <div class="mt-2 middleBox" v-if="trans_id != '' && !congModule"> 
        <app-OptVerfication :transaction_id="trans_id" :module="'1'" :title_parent="'88'" :data="''" :ticketRequestFrom="'profileOtp'" :accountId="''"></app-OptVerfication>
    </div>
    <div class="mt-2 middleBox" v-if="congModule">
        <div class="resultInfo text-center">
         <img src="../../../../static/website/images/success-icon.svg" alt="Icon">
        <p>Mobile number changed successfully</p>
        <button class="cap_btn blue" @click="$parent.editNumber = false">back</button>
        </div>
    </div>
</div>
</template>
<script>
import { supportMixins } from '@/plugins/support'
import optVerfication from '../supports/services/otp_verification'
export default {
    name: 'Edit-Address',
    mixins: [supportMixins],
    data() {
        return {
            pageLoader: false,
            notification_msg:'',
            notification_type:'',
            submitted: false,
            numberValid : true,
            userCountry : 'IN',
            numberWithCountry : '',
            trans_id : '',
            new_mobile : '',
            congModule : false
        }
    },
    components: {
        appOptVerfication : optVerfication,
    },
    methods:{
        backTick(){
          this.trans_id = ''  
        },
        updatedText(e){
            this.numberWithCountry = e.formattedNumber
            this.numberValid = e.isValid
        },
        clearDoc(getdocType){
            this.document = ''
            this.$refs.address.value = ''
        },
        submitNow(){
            if(this.pageLoader){return;}
            const _that = this
            _that.submitted = true;
            let comment = 'Please Change my Mobile Number as per following details <br> Old Number : '+ this.get_user.mobile_no + '<br> New Number : ' +  this.new_mobile
            _that.$validator.validate().then(valid => {
                if (valid && _that.numberValid){
                    let input_json={
                        'globalParams' :{
                            'mobile' : _that.numberWithCountry,
                            'reason' : '1', 
                            'reason_text' : 'Profile',
                            'title'  : '88',
                            'title_text'  : 'Change Phone Number',
                            'text' : comment
                        },
                        'localParams' :{ "parameter" : _that }
                    }
                    _that._runTicketRequestOtp(input_json)
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/website/account/edit_Number.vue